var exports = {
  "M": "x127c5a35--fec249--price-discount",
  "m": "x127c5a35--fec249--old-price",
};

module.exports = exports;
